export default __webpack_public_path__ + "static/media/recent.3b1616c9.png";